import React from 'react';
import ReactDOM from 'react-dom';
import drupalSettings from 'drupalSettings';
import Drupal from 'Drupal';
import buildUrl from 'build-url';
import {DebounceInput} from 'react-debounce-input';

if (drupalSettings.path.currentLanguage === 'en') {
    var API_URL = '/api/blogs';
}
else {
    var API_URL = '/fr/api/blogs';
}

class BlogItem extends React.Component {


    render() {
        return (
            <a className="blog-card-linked w-inline-block"
               href={this.props.blog.nothing}>
                <div className="content-card">
                    <img src={this.props.blog.field_blog_picture}
                         className="content-card-image-container"
                         alt={this.props.blog.title}/>
                    <div className="content-card-text-container">
                        <h4 className="content-card-heading"
                            dangerouslySetInnerHTML={{__html: this.props.blog.title}}></h4>
                        <h5 className="content-card-category blog w-hidden-small w-hidden-tiny"
                            dangerouslySetInnerHTML={{__html: this.props.blog.field_blog_post_type}}></h5>
                        <div className="content-card-body"
                             dangerouslySetInnerHTML={{__html: this.props.blog.field_blog_description.length > 80 ? this.props.blog.field_blog_description.substr(0, 100) + '...' : this.props.blog.field_blog_description}}></div>
                        <div
                            className="content-card-read-more blog w-hidden-small w-hidden-tiny">{Drupal.t('read more')}</div>
                    </div>
                </div>
            </a>
        )
    }
}

class LargeBlogItem extends React.Component {
    render() {
        return (
            <a className="blog-featured-card-linked w-inline-block"
               href={this.props.blog.nothing}>
                <div
                    style={{backgroundImage: `url(${this.props.blog.field_blog_picture})`}}
                    className="featured-content-card blog">
                    <div className="featured-content-card-text-container">
                        <h4 className="content-card-heading"
                            dangerouslySetInnerHTML={{__html: this.props.blog.title}}></h4>
                        <h5 className="content-card-category blog w-hidden-small w-hidden-tiny"
                            dangerouslySetInnerHTML={{__html: this.props.blog.field_blog_post_type}}></h5>
                    </div>
                </div>
            </a>
        )
    }
}

class Blog extends React.Component {
    constructor(props) {
        super(props);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleLoadMore = this.handleLoadMore.bind(this);
        this.adjustLoadMore = this.adjustLoadMore.bind(this);
        this.handleCategorySelect = this.handleCategorySelect.bind(this);
        this.state = {
            blogs: [],
            search: '',
            page: 0,
            selectedCategories: null,
            categories: drupalSettings.blog.categories,
            showLoadMore: false,
            loading: true
        };
    }

    buildUrl() {
        var query = {
            'page': this.state.page,
            '_format': 'json'
        };

        if (this.state.search !== '') {
            query.title = this.state.search
        }

        if (this.state.selectedCategories !== null) {
            query['field_blog_post_type_target_id'] = this.state.selectedCategories
        }

        var url = buildUrl(API_URL, {
            queryParams: query
        });

        return url
    }

    componentDidMount() {
        this.updateBlog()
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    updateBlog(clear) {
        var url = this.buildUrl()

        if (clear) {
            this.setState({blogs: []})
        }

        this.setState({loading: true})

        fetch(url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    blogs: this.state.blogs.concat(data.results),
                    loading: false
                })

                this.adjustLoadMore(data.pager)
            })
    }

    adjustLoadMore(pager) {
        if (parseInt(pager.count) === 0) {
            return this.setState({showLoadMore: false})
        }

        if ((parseInt(pager.pages) - 1) === parseInt(pager.current_page)) {
            return this.setState({showLoadMore: false})
        }

        if (pager.count > pager.items_per_page) {
            return this.setState({showLoadMore: true})
        }

        return this.setState({showLoadMore: true})
    }

    handleTitleChange(event) {
        this.setState({search: event.target.value});
        this.updateBlog(true)
    }

    handleLoadMore() {
        this.setState(
            {page: this.state.page + 1},
            this.updateBlog
        );
    }

    handleCategorySelect(category) {
        if (this.state.selectedCategories == category) {
            category = null
        }

        this.setState(
            {selectedCategories: category},
            () => {
                this.updateBlog(true)
            }
        )
    }

    render() {
        return (
            <div>
                <div className="blue-heading-block-short">
                    <div className="blue-heading-container blog">
                        <div className="blog-filter-search">
                            <DebounceInput minLength={2} debounceTimeout={300}
                                           className="search-input blog w-input"
                                           maxLength="256" name="query"
                                           placeholder={Drupal.t('Search')}
                                           id="search-blog" required=""
                                           type="search"
                                           value={this.state.search}
                                           onChange={this.handleTitleChange}/>
                        </div>
                        <div className="blog-filter-link-container">
                            {this.state.categories.map((category, index) => {
                                return <div
                                    className={"blog-filter-link-block w-inline-block " + (this.state.selectedCategories == category.tid ? 'active' : '')}
                                    key={index}
                                    onClick={() => this.handleCategorySelect(category.tid)}>
                                    <div
                                        className="blog-filter-link">{category.name}</div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className="content-wrapper no-margin">
                    <div className="section-blog-home">
                        <div className="high-tide-blog-container">
                            <div className="high-tide-blog-wrapper">
                                {this.state.blogs.map(function (blog, index) {
                                    return (index === 2 || index === 3) ?
                                        <LargeBlogItem blog={blog} index={index}
                                                       key={blog.nid}></LargeBlogItem> :
                                        <BlogItem blog={blog} index={index}
                                                  key={blog.nid}></BlogItem>
                                })}

                                {(this.state.loading === true) ?
                                    <div className="loading">
                                        <svg width="70px" height="70px"
                                             viewBox="140 -1 68 70"
                                             version="1.1" id="SJN_PHYhsG">
                                            <g id="rkHuwrY2jG"
                                               fillRule="evenodd">
                                                <g id="HJUuvrK3sf">
                                                    <g id="rJPdPBFnoM_HkudSK2oz">
                                                        <path
                                                            d="M0.1640625,28.1757812 C5.79354297,33.2055813 11.3312056,35.7432439 16.7770503,35.788769 C22.222895,35.8342942 27.6687397,33.3884495 33.1145845,28.4512349 C39.1033043,33.9747803 44.909886,36.781362 50.5343296,36.87098 C56.1587732,36.960598 61.7832168,34.3361544 67.4076604,28.9976492 C73.8347605,35.0245907 79.9290891,38.1189193 85.6906461,38.280635 C91.4522032,38.4423507 97.2137602,35.6807936 102.975317,29.9959639 C109.444473,35.7527492 115.437072,38.7453478 120.953113,38.9737596 C126.469154,39.2021713 131.985196,36.6861299 137.501237,31.4256352 C143.143013,36.0387188 148.515214,38.4109199 153.617841,38.5422385 C158.720467,38.6735571 163.823093,36.5709309 168.925719,32.2343598 C174.985169,37.9062501 180.86526,40.7863407 186.565991,40.8746315 C192.266722,40.9629222 197.967453,38.2621911 203.668184,32.7724381 C209.227767,37.9814772 214.823277,40.5769865 220.454712,40.5589659 C226.086148,40.5409454 231.717583,37.9095099 237.349018,32.6646595 C243.480762,39.422327 249.809573,42.7511384 256.335453,42.6510937 C262.861332,42.5510491 269.387212,39.0251696 275.913091,32.0734552 C281.933116,37.6303339 287.759216,40.4564339 293.391391,40.5517552 C299.023567,40.6470765 304.655742,38.0149012 310.287917,32.6552291 C316.005362,38.9498739 322.064831,42.0093431 328.466325,41.8336367 C334.867819,41.6579303 341.269313,38.2564362 347.670807,31.6291543 C353.197442,36.7591832 358.754763,39.3165046 364.342772,39.3011187 C369.930781,39.2857328 375.518789,36.697724 381.106798,31.5370922"
                                                            id="rJPdPBFnoM"/>
                                                    </g>
                                                    <circle id="HkuuPrFnoG"
                                                            cx="173.5" cy="33.5"
                                                            r="33.5"/>
                                                </g>
                                            </g>
                                        </svg>
                                    </div> : null}
                            </div>

                            {(this.state.loading !== true && this.state.blogs.length === 0) ?
                                <div
                                    className="noResults">{Drupal.t('No results found.')}</div> : null}

                            {(this.state.loading !== true && this.state.showLoadMore) ?
                                <div className="loadMoreWrapper"><a
                                    className="button white w-button load-more"
                                    onClick={this.handleLoadMore}>{Drupal.t('LOAD MORE')}</a>
                                </div> : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Blog;
